import { Navigation } from '../../pieces/Navigation';

export function NavMenu() {
  return (
    <>
      <Navigation to="/discover" icon="ph:hash-bold">
        <span className="max-[329px]:hidden">Discover</span>
      </Navigation>
      <Navigation to="/insight" icon="ion:analytics-sharp">
        <span className="max-[329px]:hidden">Insight</span>
      </Navigation>
      <Navigation to="/yours" icon="icon-park-solid:personal-collection">
        <span className="max-[329px]:hidden">Yours</span>
      </Navigation>
    </>
  );
}
